import { api } from '@/services/api';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_SERVICE_ACCOUNT_QUERY_KEY } from './useGetServiceAccount';

export const useDeleteServiceAccount = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { mutate, isPending, error } = useMutation({
    mutationFn: (serviceAccountId: string) => api.users.deleteUserServiceAccount(serviceAccountId),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [GET_SERVICE_ACCOUNT_QUERY_KEY] });
      onSuccess?.();
    },
    onError: error => {
      const apiError = getApiError(error, 'Failed to delete service account');
      onError?.(apiError?.message || 'Failed to delete service account');
    },
  });

  return {
    mutate,
    isPending,
    error: getApiError(error, 'Failed to delete service account')?.message,
  };
};
